import React, { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, X, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import EmailVerifyBanner from "@/components/EmailVerifyBanner";
import { Logo, AccountButton, DesktopNav, HeaderLinks, MobileMenu, BottomNav, Footer } from "@/components/layout/LayoutParts";

export { Logo };

export default function Layout() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const { user, plan } = useAuth();

  return (
    <div className="grain min-h-screen bg-[#FBF7F2]">
      <header className="sticky top-0 z-40 border-b border-[#E9E1D6] bg-[#FBF7F2]/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 md:px-8">
          <Logo />
          <DesktopNav />
          <div className="flex items-center gap-2">
            <HeaderLinks plan={plan} showSOS={loc.pathname !== "/sos"} />
            <AccountButton user={user} plan={plan} />
            <button className="grid h-11 w-11 place-items-center rounded-full lg:hidden" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-btn" aria-label="Menu">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
        {open && <MobileMenu user={user} onClose={() => setOpen(false)} />}
        {user && !user.email_verified && <EmailVerifyBanner />}
      </header>
      <main className="relative z-10 mx-auto max-w-6xl px-5 pb-32 pt-8 md:px-8 md:pb-16 md:pt-12">
        <Suspense fallback={<div className="grid min-h-[50vh] place-items-center" data-testid="page-loading"><Loader2 className="animate-spin text-[#2F4A3A]" /></div>}>
          <Outlet />
        </Suspense>
      </main>
      <BottomNav />
      <Footer />
    </div>
  );
}
